import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { FeasibilityProjectResponseDto } from "@common/dto/feasabilityProjectResponse.dto";
import { IID_FEASABILITY_ASSOCIATION } from "@common/interfaces/interfaceData";
import { Topics } from "@common/interfaces/topics";
import { Observable } from "rxjs";
import { environment } from "src/environments/environment";
import { ActionService } from "../action/action.service";
import { CrudService } from "../crudService";
import { ProjectEntityStoreStrategy } from "../updateStoreStrategies";
import { IIDFeasabilityAssociationQuery } from "./iidFeasabilityAssociation.query";
import { IIDFeasabilityAssociationStore } from "./iidFeasabilityAssociation.store";
import { InterfaceName } from "@common/interfaces/issueTypeInterface";
import { InterfaceDataService } from "../interfaceDataRegistry";

export type FeasibilityProjectWithRequestDate = FeasibilityProjectResponseDto & {
  requestDate?: string;
};

export type FeasibilityProjectsByIssueResponse = {
  idBuilding: string;
  gisfoBuildingId: string;
  projects: FeasibilityProjectWithRequestDate[];
};

@Injectable({
  providedIn: 'root'
})
@InterfaceDataService(InterfaceName.IID_FEASABILITY_ASSOCIATION)
export class IIDFeasabilityAssociationService extends CrudService<IID_FEASABILITY_ASSOCIATION, IIDFeasabilityAssociationStore, IIDFeasabilityAssociationQuery> {
  constructor(
    protected store: IIDFeasabilityAssociationStore,
    public query: IIDFeasabilityAssociationQuery,
    protected actionService: ActionService,
    protected updateStrategy: ProjectEntityStoreStrategy,
    protected http: HttpClient,
  ) {
    super(
      Topics.IID_FEASABILITY_ASSOCIATION,
      store,
      query,
      actionService,
      updateStrategy,
    );
  }

  readFromGisfo(issueId: string): Observable<FeasibilityProjectsByIssueResponse> {
    return this.http.get<FeasibilityProjectsByIssueResponse>(
      `${environment.apiUrl}/api/iid_feasability_association/issue/${issueId}/feasibilityProjects`
    );
  }
}
